import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { ICONS } from 'components/Icon';
import { ModalScreens } from 'components/Navigation/types';
import { useSelector } from 'hooks/useSelector';
import { theme } from 'lib/theme';
import React from 'react';
import { useDispatch } from 'react-redux';
import { NAVIGATE_MODAL } from 'store/actions';
import { selectBillingDiscountIds } from 'store/remote/selectors';
import { BillingDiscountCard } from './BillingDiscountCard';
import { GapSmall } from 'components/GapSmall';

type Props = {};

export const BillingDiscountCards: React.FC<Props> = () => {
  const dispatch = useDispatch();

  const billingItemIds = useSelector(selectBillingDiscountIds) || [];
  return (
    <GapSmall>
      <Card label="Discounts" />
      {!!billingItemIds.length && (
        <Card>
          {billingItemIds.map((itemId) => (
            <BillingDiscountCard key={itemId} itemId={itemId} />
          ))}
        </Card>
      )}
      <Card>
        <CardRow
          label="Add discount..."
          labelColor={theme.colors.blue}
          icon={ICONS.PlusLight}
          iconColor={theme.colors.blue}
          onPress={() =>
            dispatch(
              NAVIGATE_MODAL({
                screen: ModalScreens.SettingsBillingDiscount,
                params: { itemId: null },
              }),
            )
          }
        />
      </Card>
    </GapSmall>
  );
};
